/**
 * Guest-realm source for the Task Manager extension. This panel has no
 * sidebar tree and no host-RPC needs — TaskBoardTab.js (host-rendered, full
 * page) reads/writes board files directly via Tauri invoke(), bypassing the
 * guest sandbox entirely. This entry script is a no-op kept only to satisfy
 * the extension registration contract (every extension needs a valid entry).
 */
export const taskManagerEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
